(ns bp-clients.tv-app.pages.search
  (:require ["react" :refer [createRef]]
            [bp-clients.tv-app.common.components.thumb :as thumb-components]
            [bp-clients.tv-app.common.components.vertical-scroll-with-lazy-rendering :refer [vertical-scroll-with-lazy-rendering]]
            [bp-clients.tv-app.nav.events :as nav-events]
            [bp-clients.tv-app.nav.subs :as nav-subs]
            [bp-libs.design-system.components.grid :refer [grid]]
            [bp-libs.design-system.components.keyboard :refer [keyboard]]
            [bp-libs.design-system.components.text-input :refer [single-line-input-text]]
            [clojure.string]
            [goog.functions :refer [debounce]]
            [re-frame.core :as rf]))

(def ^:private do-search (debounce #(rf/dispatch [::nav-events/fetch-search %]) 1000))

(defn- on-keyboard-item-click-fn
  "When typing with virtual keyboard"
  [text-search]
  (fn [value]
    (let [refresh? (not (and (nil? (seq text-search))
                             (contains? #{:backspace :clean-all} value)))
          search-terms (case value
                         :backspace
                         (clojure.string/join (butlast text-search))

                         :clean-all
                         ""

                         (str text-search value))]
      (when refresh?
        (rf/dispatch [::nav-events/set-search-term search-terms])
        (do-search search-terms)))))

(defn- on-text-input-change
  "When typing by real keyboard, directly inside
  input text."
  [event]
  (let [search-terms (-> event .-target .-value)]
    (rf/dispatch [::nav-events/set-search-term search-terms])
    (rf/dispatch [::nav-events/fetch-search search-terms])))

(defn- gen-loading-shimmers
  [count]
  (mapv (fn [_]
          [thumb-components/safe-thumb {:container {:aspect-ratio {:w "11" :h "16"}}}])
        (range count)))

#_{:clj-kondo/ignore [:used-underscored-binding]}
(defn search []
  (let [active-page-data (rf/subscribe [::nav-subs/active-page-data])
        ref-block        (createRef)]
    (fn []
      (let [{:keys [components search-term]} (:search @active-page-data)]
        [:div {:ref ref-block
               :class ["bg-black min-h-screen pl-14 relative overflow-hidden"]}
         [:div {:class ["flex space-x-20 -mt-8"]}

          ;; keyboard
          [:div {:class ["min-w-[17rem] w-1/3 mt-24"]}
           [:div {:class ["w-full"]}
            [keyboard {:tab-index 10
                       :on-item-click (on-keyboard-item-click-fn search-term)}]]]

          ;; input text and results
          [:div {:class ["w-3/4 h-full overflow-hidden mt-20 pr-4"]}
           [:div {:class ["h-[10vh] w-full"]}
            [:div {:class ["z-10 w-full"]}
             [single-line-input-text {:value search-term
                                      :on-change on-text-input-change
                                      :class "pr-4"}]]]

           ^{:key (hash components)}
           [:div {:class ["overflow-hidden hide-scroll-bar overflow-y-scroll h-[80vh]"]}
            [:div {:class ["flex flex-col flex-grow"]}
             [:div {:class "space-y-10 mt-6"}
              (when (nil? components)
                (let [shimmers (gen-loading-shimmers 10)]
                  [grid {:items shimmers
                         :columns 5
                         :items-classes ["border-4 border-transparent"]}]))

              (when (and ((comp not nil?) components) (nil? (seq components)))
                [:p {:class "text-gray-50 font-medium text-3xl"}
                 "Não encontramos nenhum resultado para sua pesquisa"])

              (when (seq components)
                (.focus js/SpatialNavigation "content")
                [vertical-scroll-with-lazy-rendering {:components components}])]]]]]]))))
